import React from 'react';
import { useCookies } from 'react-cookie';
import WithIdleTimer from './WithIdleTimer';
import Routes from '../Navigator/Navigator.route';
import { deleteAllCookie } from '../../utils/common.util';

const withIdleTimeout = (Component) => (props) => {
  const [, , removeCookie] = useCookies(['']);
  const handleOnIdle = () => {
    if ((window as any).intervalId1 || (window as any).intervalId2) {
      clearInterval((window as any).intervalId1);
      clearInterval((window as any).intervalId2);
    }
    removeCookie('userInfo');
    removeCookie('role');
    deleteAllCookie();
    setTimeout(() => {
      props.history.push(Routes.SignIn);
    }, 600);
  };

  return (
    <>
      <Component {...props} />
      <WithIdleTimer handleIdle={handleOnIdle} />
    </>
  );
};

export default withIdleTimeout;
